import { render, staticRenderFns } from "./ShowCards.html?vue&type=template&id=42ab7cf8&scoped=true&"
import script from "./ShowCards.js?vue&type=script&lang=js&"
export * from "./ShowCards.js?vue&type=script&lang=js&"
import style0 from "./ShowCards.scss?vue&type=style&index=0&id=42ab7cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ab7cf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
